import { supabase } from "./supabase";

export const GOOGLE_CAL_CALLBACK = "https://app.brxs.ca/auth/google-calendar";
export const GOOGLE_CAL_SCOPE = "https://www.googleapis.com/auth/calendar.events";

/** Start Google Calendar OAuth. Direct (client secret on API) or Supabase-mediated. */
export async function startGoogleCalendarOAuth(startBody) {
  if (startBody?.url) {
    window.location.href = startBody.url;
    return { redirected: true };
  }
  if (startBody?.mode === "supabase") {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: startBody.redirect_uri || GOOGLE_CAL_CALLBACK,
        scopes: startBody.scope || GOOGLE_CAL_SCOPE,
        queryParams: {
          access_type: "offline",
          prompt: "consent",
        },
      },
    });
    if (error) {
      return { error: error.message || "Could not start Google Calendar connect." };
    }
    return { redirected: true };
  }
  return { error: "Google Calendar permission is not granted yet." };
}
